export default import.meta.ROLLDOWN_FILE_URL_0xFrBP2sToTV9Q0V6r2CxQ